import createVueComponent from '../createVueComponent';

const ArrowDownLeft = createVueComponent('ArrowDownLeftIcon', [
  ['path', { d: 'M17 7 7 17', key: '15tmo1' }],
  ['path', { d: 'M17 17H7V7', key: '1org7z' }],
]);

export default ArrowDownLeft;
